<template>
  <div>
    <Card>
      <Row style="margin-bottom: 10px">
        <Button type="info" @click="add">{{$t('pages_limited_time_activity_index_584')}}</Button>
      </Row>
      <i-table :columns="columns" :data="limited_time_activities" :loading="loading">
        <template slot="rules" slot-scope="{ row }">
          <p v-for="(rule, index) in ruleList(row)" :key="index"><b>{{ index + 1 }}.</b> {{ rule }}</p>
        </template>
        <template slot="is_running" slot-scope="{ row }">
          <tag color="green" v-if="row.is_running">{{$t('pages_combo_index_277')}}</tag>
          <tag v-else>{{$t('pages_combo_index_278')}}</tag>
        </template>
        <template slot="start_at" slot-scope="{ row }">
          {{ fmt(row.start_at) }}
        </template>
        <template slot="stop_at" slot-scope="{ row }">
          {{ fmt(row.stop_at) }}
        </template>
      </i-table>
      <Page :total="meta.total" :current="meta.current" show-total :page-size="meta.pageSize" @on-change="changePage">
      </Page>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" width="660" :title="$t('pages_limited_time_activity_index_585')">
      <Form ref="limited_time_activity" :model="form" :label-width="80">
        <Form-Item :label="$t('pages_combo_index_280')" prop="name">
          <Input :placeholder="$t('pages_combo_index_281')" v-model="form.name" />
        </Form-Item>
        <Form-Item :label="$t('pages_limited_time_activity_index_586')" prop="description">
          <Input :placeholder="$t('pages_limited_time_activity_index_587')" v-model="form.description" />
        </Form-Item>
        <Form-item :label="$t('pages_booking_store_products_index_213')">
          <Select label-in-value :placeholder="$t('pages_limited_time_activity_index_588')" v-model="form.fresh_category_id">
            <Option value="-1">{{$t('pages_customers_index_309')}}</Option>
            <Option v-for="(cat, index) in all_categories" :value="cat.id" :key="index">{{ cat.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_banners_index_185')">
          <Select label-in-value :disabled="!!form.id" v-model="form.category">
            <Option v-for="item in activity_categories" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-Item :label="$t('pages_enough_consume_discount_index_483')" prop="rules">
          <RuleList :category="form.category" v-model="form.rules" />
        </Form-Item>
        <Form-Item :label="$t('pages_enough_consume_discount_index_485')" prop="stop_at">
          <Date-Picker type="date" v-model="form.stop_at" />
        </Form-Item>
      </Form>
      <template slot="footer">
        <i-button @click="modalShow = false" type="text" style="margin-right: 12px">{{$t('pages_city_shop_freights_index_250')}}</i-button>
        <i-button @click="handleSubmit" type="primary">{{$t('pages_combo_index_284')}}</i-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
// import TablePaginate from '@/components/TablePaginate'
import moment from 'moment';
import { deleteButtonInTable, editorButtonInTable, toggleRunButtonInTable } from '@/libs/table-render'
import RuleList from './rule-list';

const getDefaults = () => {
  return {
    category: 'amount',
    fresh_category_id: '-1',
    name: '',
    rules: [],
    description: ''
  };
}

export default {
  components: {
    // TablePaginate,
    RuleList
  },
  watch: {
    limited_time_activity(val) {
      if (val && val.id) {
        if (!val.fresh_category_id) {
          val.fresh_category_id = '-1'
        }
        this.form = {
          ...val,
          rules: val.rules || [],
        };
      }
    }
  },
  data() {
    return {
      activity_categories: [
        { text: i18n.t('pages_limited_time_activity_index_589'), code: i18n.t('pages_limited_time_activity_index_589') },
        { text: i18n.t('pages_limited_time_activity_index_590'), code: i18n.t('pages_limited_time_activity_index_590') }
      ],
      form: getDefaults(),
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_limited_time_activity_index_591'),
          key: 'name',
        },
        {
          title: i18n.t('pages_balance_transaction_index_174'),
          key: 'description',
        },
        {
          title: i18n.t('pages_booking_store_products_index_213'),
          key: 'fresh_category_name',
          render: (h, params) => {
            console.info('params', params)
            return h('span', params.row.fresh_category_name || i18n.t('pages_customers_index_309'))
          }
        },
        {
          title: i18n.t('pages_limited_time_activity_index_592'),
          key: 'category',
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_483'),
          key: 'rules',
          slot: 'rules'
        },
        {
          title: i18n.t('pages_enough_consume_discount_index_485'),
          key: 'stop_at',
          slot: 'stop_at'
        },
        {
          title: i18n.t('pages_balance_transaction_index_176'),
          key: 'is_running',
          slot: 'is_running',
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 250,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            children.push(toggleRunButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created() {
    this.allCategory({})
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('category', ['all_categories']),
    ...mapState('limited_time_activity', ['limited_time_activity', 'limited_time_activities', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('limited_time_activity', [
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'toggleRun'
    ]),
    ...mapActions('category', ['allCategory']),
    ...mapMutations('limited_time_activity', ['changeQuery']),
    changePage(page) {
      this.changeQuery({ page: page })
      this.index()
    },
    // change_category (e) {
    //   console.log('e', e)
    //   this.form.category = e.value
    // },
    // change_goods_category (e) {
    //   console.log('e', e)
    //   this.form.fresh_category_id = e.value
    // },
    add() {
      this.form = getDefaults()
      this.modalShow = true
      this.formType = 'new'
    },
    toggleRunning(row) {
      this.toggleRun(row.id).then(() => {
        this.$Message.success(i18n.t('pages_combo_index_287'));
        this.index({ page: this.meta.page })
      }, (e) => {
        const message = ((e.response && e.response.data) && e.response.message) || i18n.t('pages_combo_index_288');
        this.$Message.error(message);
      });
    },
    async handleSubmit() {
      const payload = { ...this.form };
      if (payload.fresh_category_id == '-1') {
        payload.fresh_category_id = ''
      }
      delete payload.fresh_category_name
      // payload.start_at = moment(payload.start_at).format('YYYY-MM-DD HH:mm:ss');
      // payload.end_at = moment(payload.end_at).format('YYYY-MM-DD HH:mm:ss');

      // if (moment(payload.start_at).isAfter(moment(payload.end_at))) {
      //   this.$Message.error('结束时间不能小于开始时间');
      //   return;
      // }

      if (this.formType === 'edit') {
        await this.update(payload)
      } else if (this.formType === 'new') {
        await this.create(payload)
      }
      this.index({ page: this.meta.page })
      this.modalShow = false
    },
    ruleList(row) {
      if (row.category === i18n.t('pages_limited_time_activity_index_589')) {
        return row.rules.map(i => {
          return i18n.t('pages_limited_time_activity_index_593', [i.start_at,i.end_at,i.cut]);
        });
      } else {
        return row.rules.map(i => {
          return i18n.t('pages_limited_time_activity_index_594', [i.start_at,i.end_at,i.cut]);
        });
      }
    },
    fmt(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
